import { useAuth } from './useAuth'

export function useUserGroups() {
  return useAuth().groups
}
